'use strict';

var index = require('./index-891ee644.js');

var React = require('react');

var isEqual = require('react-fast-compare');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var isEqual__default = /*#__PURE__*/_interopDefaultLegacy(isEqual);

var useCustomTabs = function useCustomTabs(tabs, uploadcare) {
  React.useEffect(function () {
    var customTabs = Object.entries(tabs || []);
    customTabs.forEach(function (_ref) {
      var _ref2 = index._slicedToArray(_ref, 2),
          name = _ref2[0],
          implementation = _ref2[1];

      uploadcare.registerTab(name, function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return implementation.apply(void 0, args.concat([uploadcare]));
      });
    });
  }, [tabs, uploadcare]);
};

var useDeepEffect = function useDeepEffect(effect, deps) {
  var ref = React.useRef(undefined);

  if (!isEqual__default['default'](deps, ref.current)) {
    ref.current = deps;
  } // eslint-disable-next-line react-hooks/exhaustive-deps


  React.useEffect(effect, ref.current);
};

exports.useCustomTabs = useCustomTabs;
exports.useDeepEffect = useDeepEffect;